export default __webpack_public_path__ + "static/logo_efro_black-784bd2f40b7253f5a0c01d438dbf20c5.png";